import { helpers } from 'vuelidate/lib/validators';
import slugify from 'slugify';

export const minSlugLength = (param: number) =>
  helpers.withParams({ type: 'minSlugLength' }, (value: string) => slugify(value).length >= param);
